export { default } from './BlockTeaserCarousel';

export { default as TeaserItem } from './TeaserItem';
export type { Props as TeaserItemProps } from './TeaserItem';
